// Admin CMS

import React, { useEffect, useState } from "react";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import AddButton from "../../../../reusable-components/buttons/AddButton";
import H2withIcon from "../../../../reusable-components/headings/H2withIcon";
import SpinnerWithText from "../../../../reusable-components/loader/SpinnerWithText";
import { IconContext } from "react-icons";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { SHIPPING_POLICY_CONFIG_URL } from "../../../../api/api_routing_urls";
import { ToastContainer } from "react-toastify";
import showToast from "../../../../utilities/notification/NotificationModal";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import ContainerShadow from "../../../../reusable-components/containers/ContainerShadow";
import AddShippingPolicy from "./addShippingPolicy.component";
// import useAuth from "../../../../authentication/hooks/useAuth";

const ShippingPolicyAdmin = () => {
  // const { auth } = useAuth();

  const [showAddForm, setShowAddForm] = useState(false);
  const [shippingPolicy, setShippingPolicy] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // const axiosPrivate = useAxiosPrivate();

  const isEdit =
    shippingPolicy !== undefined
      ? Object.keys(shippingPolicy).length > 0
      : false;

  const getShippingPolicyDetails = async () => {
    try {
      const response = await axios.get(SHIPPING_POLICY_CONFIG_URL);

      response.status === 200 &&
        setShippingPolicy(response?.data?.shippingPolicyDetails);
      response.status === 202 &&
        showToast("Shipping Policy details not found in the system.", "error");
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    isMounted && getShippingPolicyDetails();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Dashboard>
      <ToastContainer />
      <div className="flex items-center justify-between">
        <H2withIcon>
          <IconContext.Provider value={{ className: "text-black" }}>
            <BsFillInfoCircleFill />
          </IconContext.Provider>
          &nbsp; Shipping Policy
        </H2withIcon>
        {!showAddForm && (
          <AddButton
            label={`${
              isEdit ? "Update Shipping Policy" : "Add Shipping Policy"
            }`}
            onclick={() => setShowAddForm(true)}
          />
        )}
      </div>
      {showAddForm ? (
        <AddShippingPolicy
          getShippingPolicyDetails={getShippingPolicyDetails}
          shippingPolicy={shippingPolicy}
          setShippingPolicy={setShippingPolicy}
          setShowAddForm={setShowAddForm}
        />
      ) : (
        <ContainerShadow>
          {!isEdit ? (
            <p>Shipping Policy content yet to be added!</p>
          ) : (
            <div>
              <br />
              <label>
                Shipping Policy:
                <br />
              </label>
              <div
                dangerouslySetInnerHTML={{
                  __html: shippingPolicy.shipping_policy_content,
                }}
              />
            </div>
          )}
        </ContainerShadow>
      )}
    </Dashboard>
  );
};

export default ShippingPolicyAdmin;
